"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountTypeName = exports.Purpose = void 0;

var _AccountTypeName;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This module exports purpose constants as defined in BIPs 44/49/84 and
 * human-readable account-type names.
 *
 * @module purpose
 */

/**
 * Derivation purpose as defined in BIP 44.
 *
 * @constant
 * @enum {string}
 */
var Purpose = {
  /** BIP 44: Pay To Pubkey Hash (addresses starting with 1) */
  P2PKH: "44",
  // 1...

  /** BIP 49: Pay To Witness Pubkey Hash nested in Pay To Script Hash (addresses starting with 3) */
  P2SH: "49",
  // 3...

  /** BIP 84: Pay To Witness Pubkey Hash (addresses starting with bc1) */
  P2WPKH: "84" // bc1...

};
/**
 * Human-readable account names
 *
 * @constant
 * @enum {string}
 */

exports.Purpose = Purpose;
var AccountTypeName = (_AccountTypeName = {}, _defineProperty(_AccountTypeName, Purpose.P2PKH, "Legacy"), _defineProperty(_AccountTypeName, Purpose.P2SH, "SegWit"), _defineProperty(_AccountTypeName, Purpose.P2WPKH, "Native SegWit"), _AccountTypeName);
exports.AccountTypeName = AccountTypeName;